import handleTags from 'utils/tags'

export default $list => {
  const getListData = () => {
    const { estatesList, pagination } = $list
    const newEstatesList = estatesList.map(property => ({
      ...property,
      tags: handleTags(property.tags || []),
    }))

    return {
      list: newEstatesList,
      pagination,
    }
  }

  const isListLoading = () => $list.loadingList

  return { getListData, isListLoading }
}
